import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/(error)/404Client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/vercel/path0/apps/web/src/components/layouts/Layout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/ui/backToTop/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
